import { urlGlobal2 } from './GlobalService.js';

const getMenuCacheKey = (token) => `menu-cache:${token || "anonymous"}`;

const readMenuCache = (token) => {
    if (typeof sessionStorage === "undefined") {
        return null;
    }

    const cachedMenu = sessionStorage.getItem(getMenuCacheKey(token));
    if (!cachedMenu) {
        return null;
    }

    try {
        return JSON.parse(cachedMenu);
    } catch (error) {
        sessionStorage.removeItem(getMenuCacheKey(token));
        return null;
    }
}

const writeMenuCache = (token, menu) => {
    if (typeof sessionStorage === "undefined") {
        return;
    }

    sessionStorage.setItem(getMenuCacheKey(token), JSON.stringify(menu));
}

export const clearMenuCache = () => {
    if (typeof sessionStorage === "undefined") {
        return;
    }

    const token = localStorage.getItem('token');
    sessionStorage.removeItem(getMenuCacheKey(token));
}

export const getMenu = async(params=null, options = {}) =>{
    let url = new URL(`${urlGlobal2}/menu`)
    if (params != null) {
        url.search = new URLSearchParams(params).toString();
        
    }
    try{
        let token = localStorage.getItem('token');
        const useCache = params == null && !options.forceRefresh;

        if (useCache) {
            const cachedMenu = readMenuCache(token);
            if (cachedMenu) {
                return cachedMenu;
            }
        }

        let headers = {'Content-Type':'application/json', token}
        let method = 'GET';
        let resp = await fetch(url,{method, headers});
        let data = await resp.json();

        if (useCache && Array.isArray(data)) {
            writeMenuCache(token, data);
        }

        return data;
    }
    catch(error){
        return null;
    }
}
